﻿import { IComponent, Component, Inject, Input } from "@fiqas/angular-utils"
import { FIQAssist } from "../app"
import { AuthorizationService } from "../services/authorizationService";

export interface MenuInformation {
    title: string;
    icon: string;
    tooltip: string;
}

export interface ProvidesMenuInformation {
    menuinformation: MenuInformation;
}

export interface MenuEntry {
    id: string;
    link: string[];
    title: string;
    subtitle: string;
    icon: string;
    highlighticon?: string;
    ishome?: boolean;
    isvisible: boolean;
    isdisabled: () => boolean;
    item?: MainMenuItem;
    isfocus?: boolean;
}

@Component({
    module: FIQAssist,
    selector: "mainmenu",
    templateUrl: "views/mainMenu.html",
})
export class MainMenu implements IComponent {
    private menuItems: MenuEntry[] = [
        { id: 'home', link: ["Home"], title: 'HOME', subtitle: '', icon: 'icon-home', ishome: true, isvisible: true, isdisabled: () => false },
        { id: 'problem', link: ["Problem", "New"], title: 'REPORT_BUG', subtitle: 'REPORT_BUG_SUB', icon: 'icon-problem', isvisible: true, isdisabled: () => this.authorizationService.currentRoleIn(["FQS"]) },
        { id: 'request', link: ["Request", "New"], title: 'DO_REQUEST', subtitle: 'DO_REQUEST_SUB', icon: 'icon-request', isvisible: true, isdisabled: () => this.authorizationService.currentRoleIn(["FQS"]) },
        { id: 'compliment', link: ["Compliment"], title: 'GIVE_COMPLIMENT', subtitle: 'GIVE_COMPLIMENT_SUB', icon: 'icon-compliment', isvisible: true, isdisabled: () => false },
        { id: 'complaint', link: ["Complaint"], title: 'ISSUE_COMPLAINT', subtitle: 'ISSUE_COMPLAINT_SUB', icon: 'icon-complaint', isvisible: true, isdisabled: () => false },
        { id: 'reports', link: ["Reports"], title: 'SERVICE_CASE_REPORTS', subtitle: 'SERVICE_CASE_REPORTS_SUB', icon: 'icon-Report', isvisible: true, isdisabled: () => false },
        { id: 'other', link: ["Other"], title: 'OTHER_FUNCTIONS', subtitle: 'OTHER_FUNCTIONS_SUB', icon: 'icon-other', isvisible: false, isdisabled: () => false },
    ];

    constructor(
        @Inject('') private authorizationService: AuthorizationService,
        @Inject('$window') private $window: ng.IWindowService,
        @Inject('$rootRouter') private $router: angular.Router,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$element') private $element: angular.IRootElementService) {
        this.$window.addEventListener('resize', () => this.ajustDynamicHTMLLayout());
    }

    public $onInit() {
        var element = this.$element;
        this.$timeout(() => {
            if (this.focusinput) {
                (<HTMLElement>(element[0].getElementsByClassName('menucontent').item(0))).focus();
            }
        });
        this.ajustDynamicHTMLLayout();
    }

    public ajustDynamicHTMLLayout() {
        if ((<HTMLElement>this.$element[0].getElementsByClassName('menucontent').item(0)).getBoundingClientRect().left > 175) {
            this.placementToolbar = "left";
        } else {
            this.placementToolbar = "right";
        }
    }

    public placementToolbar: string = "right"

    @Input() public expanded: boolean;
    @Input() public hidehome: boolean;
    @Input() public focusinput: boolean;

    private _activeMenuItem: string;
    @Input()
    public get activeMenuItem(): string {
        return this._activeMenuItem;
    }
    public set activeMenuItem(name: string) {
        this._activeMenuItem = name;
    }

    private _highlightMenuItem: string;
    @Input()
    public get highlightMenuItem(): string {
        return this._highlightMenuItem;
    }
    public set highlightMenuItem(name: string) {
        this._highlightMenuItem = name;
    }

    private onBlur() {
        if (this.hovered)
            this.hovered.isfocus = false;
    }

    private onFocus() {
        if (!this.hovered) {
            this.hovered = this.allowedItems.shift();
        }
        if (this.hovered)
            this.hovered.isfocus = true;
    }

    private onKey($event: KeyboardEvent) {
        switch ($event.keyCode) {
            case 38:
                $event.preventDefault();
                this.move(-1);
                break;

            case 40:
                $event.preventDefault();
                this.move(1);
                break;

            case 13:
            case 32:
                $event.preventDefault();
                this.select();
                break;

        }
    }

    private hovered: MenuEntry = null;

    private get allowedItems() {
        return this.menuItems.filter(x => x.isvisible && !(x.ishome && this.hidehome) && x.id != this.activeMenuItem && !x.isdisabled());
    }


    private move(direction: number) {
        var newindex = Math.max(0, Math.min(this.allowedItems.length - 1, this.allowedItems.indexOf(this.hovered) + direction));
        if (this.hovered != null)
            this.hovered.isfocus = false;
        this.hovered = this.allowedItems[newindex];
        this.hovered.isfocus = true;
    }

    private select() {
        if (this.hovered != null && !this.hovered.isdisabled()) {
            this.hovered.isfocus = false;
            this.$router.navigate(this.hovered.link);
        }
    }

}

@Component({
    module: FIQAssist,
    selector: "mainmenuitem",
    templateUrl: "views/mainMenuItem.html",
    require: {
        mainMenu: "^mainmenu"
    }
})
export class MainMenuItem {
    private _show: boolean;
    public get isvisible() {
        return this._show && (!this.entry.ishome || !this.expanded);
    }

    @Input() public placementToolbar: string = "right";

    public mainMenu: MainMenu;

    public get isfocus() {
        return this.entry && this.entry.isfocus;
    }

    public get ishighlight() {
        return this.mainMenu && this.mainMenu.highlightMenuItem == this.id;
    }

    public get isactive() {
        return this.mainMenu && this.mainMenu.activeMenuItem == this.id;
    }

    public get isdisabled(): boolean {
        return this.entry ? this.entry.isdisabled() : true;
    }

    public get expanded() {
        return this.mainMenu && this.mainMenu.expanded;
    }

    public get link() {
        return (this.entry && !this.isdisabled) ? this.entry.link : ['home'];
    }

    public get title() {
        return (this.entry && !this.isdisabled) ? this.entry.title : "";
    }

    public get icon() {
        return this.ishighlight && this.entry && this.entry.highlighticon ?
            this.entry.highlighticon :
            this.entry ?
                this.entry.icon : "";
    }

    constructor() {
    }
    private get id() {
        return this.entry ? this.entry.id : "-1";
    }

    private _entry: MenuEntry;
    @Input() public get entry() {
        return this._entry;
    }
    public set entry(entry: MenuEntry) {
        this._entry = entry;
        if (entry)
            entry.item = this;
    }

    $onInit() {
        this._show = this.entry.isvisible;
    }
}

